import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Main from './Main';
import Search from './Search';
import Pacchetto from './Pacchetto';

export default function Navigator() {
    console.log("ciao dal navigator")
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Search />} />
                <Route path="/RegistraAcquisto" element={<Main />} />
                <Route path="/RegistraPacchetto" element={<Pacchetto />} />
            </Routes>
        </BrowserRouter>

    )
}